import {css} from 'lit'; export default css`.hotkey-settings{width:820px}`;
    